import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { Router } from '@angular/router';
import { Constantes } from '../../shared/constant/constantes';
import { DataAccordion } from '../../shared/entities/data-accordion';
import { MenuEstadistica } from '../../shared/entities/menu-estadistica';
import { VisualizadorService } from '../../shared/service/visualizador.service';
import { UtilidadGeneraTabla } from '../../shared/utilities/utilidad-genera-tabla';
import { UtilidadMenuEstadisticas } from '../../shared/utilities/utilidad-menu-estadisticas';
import { NotasFeErratas } from '../dialog/nota-fe-errata/nota-fe-errata.component';
import { CdkAccordionItem } from '@angular/cdk/accordion';
import { DatosSerieResponse } from '../../shared/entities/DatosSerieResponse';
import { HeaderComponent } from '../../shared/header/header.component';
import { MenuAlternoComponent } from '../public/menu-alterno/menu-alterno.component';
import {CdkAccordionModule} from '@angular/cdk/accordion';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { environment } from '../../../../environments/environment.development';

@Component({
    selector: 'app-encuestas-boletines',
    templateUrl: './encuestas-boletines.component.html',
    styleUrls: ['./encuestas-boletines.component.css'],
    standalone: true,
    imports: [CommonModule, HeaderComponent, MenuAlternoComponent, CdkAccordionModule, MatIconModule, MatExpansionModule]
})
export class EncuestasBoletinesComponent implements OnInit {

    public utilidadTabla: UtilidadGeneraTabla = new UtilidadGeneraTabla();
    public constante: Constantes = new Constantes();
    public ume: UtilidadMenuEstadisticas = new UtilidadMenuEstadisticas();

    public listaCatalogo: Array<MenuEstadistica> = new Array();
    public listaDataAccordion: Array<DataAccordion> = new Array();

    public listaDataAccordionFiltro: Array<DataAccordion> = new Array();

    public infoSerieSeleccionada: DatosSerieResponse = new DatosSerieResponse();

    public listaNotasNM: Array<NotasFeErratas> = new Array();

    public oracleReportDV: string = environment.URL_ORACLE_REPORT_DV;

    @ViewChildren('accordionSubItem') accordionSubItems!: QueryList<CdkAccordionItem>;

    constructor(private service: VisualizadorService, private router: Router, private location: Location) { }

    ngAfterViewInit(): void {
        this.service.setWindowScroll(0, 0);
    }

    ngOnInit(): void {
        const currentUrl = this.location.path();
        this.service.generaTagsHtmlSEO('Boletínes','Boletínes','Boletínes',currentUrl);
        this.generaMenuDinamico();
    }

    private generaMenuDinamico() {
        this.service.getMenuXOpcion('BOLETINES').subscribe({
            next: (listaCatalogoMenu) => {
                this.listaCatalogo = listaCatalogoMenu;
                this.listaDataAccordion = this.getMenuAccordion(this.listaCatalogo);

                this.listaDataAccordionFiltro = this.listaDataAccordion;
            },
            error: (error) => {
                console.log("Error inesperado en getMenuXOpcion", error);
            }
        });
        setTimeout(() => {
            this.consultaInformacionSerie();
        }, 1000);
    }

    public getMenuAccordion(catalogoSelect: Array<MenuEstadistica>): Array<DataAccordion> {
        let result: Array<DataAccordion> = new Array();
        let dataAccordion: DataAccordion;
        catalogoSelect?.forEach((catalogo) => {
            dataAccordion = this.getObjetoAccordion(catalogo);
            let hijo: DataAccordion;
            catalogo.menuHijos?.forEach((menuHijo) => {
                hijo = this.getObjetoAccordion(menuHijo);
                var listaDatos: Array<NotasFeErratas> = new Array();
                var listaDocumentos: Array<NotasFeErratas> = new Array();
                var listaCuestionarios: Array<NotasFeErratas> = new Array();
                    var guiasNotas = menuHijo.listaDocumento;
                    guiasNotas?.forEach((notaDoc: NotasFeErratas) => {
                        if (notaDoc.tipo === 'DATOS') {
                            listaDatos.push(notaDoc);
                        } else if (notaDoc.tipo === 'DOCUMENTOS') {
                            listaDocumentos.push(notaDoc);
                        } else {
                            listaCuestionarios.push(notaDoc);
                        }
                    });
                if (listaDatos.length > 0) {
                    hijo.menuHijos.push(this.getObjAccordionFromNotaFeDoc(hijo.id, 'Datos', listaDatos));
                }
                if (listaDocumentos.length > 0) {
                    hijo.menuHijos.push(this.getObjAccordionFromNotaFeDoc(hijo.id, 'Documentos metodológicos', listaDocumentos));
                }
                if (listaCuestionarios.length > 0) {
                    hijo.menuHijos.push(this.getObjAccordionFromNotaFeDoc(hijo.id, 'Cuestionarios', listaCuestionarios));
                }
                dataAccordion.menuHijos.push(hijo);
            });
            result.push(dataAccordion);
        });
        return result;
    }

    private getObjetoAccordion(menuEstadistica: MenuEstadistica): DataAccordion {
        let result: DataAccordion = new DataAccordion();
        result.id = menuEstadistica.id;
        result.nombre = menuEstadistica.nombre;
        result.display = false;
        result.iconDisplay = 'add';
        result.enlace_pagina_externa = menuEstadistica.enlace_pagina_externa;
        return result;
    }

    private getObjAccordionFromNotaFeDoc(id: number, nombre: string, listaNota: Array<NotasFeErratas>): DataAccordion {
        let result: DataAccordion = new DataAccordion();
        result.id = id;
        result.nombre = nombre;
        result.display = false;
        result.iconDisplay = 'add';
        result.guiasNotas = listaNota;
        return result;
    }

    private consultaInformacionSerie() {
        this.listaDataAccordion?.forEach(padre => {
            padre.menuHijos?.forEach(hijo => {
                this.service.consultaSerieActiva(hijo.enlace_pagina_externa).subscribe({
                    next: (serieResponse) => {
                        if(serieResponse && serieResponse.length > 0){
                            hijo.definicion = serieResponse[0].definicion;
                            hijo.informacionSerie = serieResponse[0];
                        }
                    },
                    error: (error) => {
                        console.log("Error inesperado en consultaSerieActiva", error);
                    }
                });
            });
        });
    }

    public abrirEnlace(nota: any) {   
        var archivo = this.ume.removeHashFromUrl(nota.nombreAdjunto);
        if (archivo.includes('pdf') && !archivo.includes('https:') && !archivo.includes('http:')) {
            this.service.consultaArchivo(archivo)
                .subscribe(dataResponse => {
                    debugger
                    var newBlob = new Blob([dataResponse], { type: "application/pdf" });
                    const data = this.service.createObjectURL(newBlob);
                    this.service.windowOpen(data, '_blank');
                });
        } else if (archivo.includes('estadisticas-economicas')) {
            console.log('archivo',archivo);
            var urlReporte = this.service.getUrlBase() + archivo;
            console.log('urlReporte',urlReporte);
            this.service.windowOpen(urlReporte, '_self');
        } else if (archivo.includes('%2FTrabajo')) {
            var urlReporte = this.oracleReportDV + archivo;
            this.service.windowOpen(urlReporte, '_blank');
        } else if (archivo.includes('https:')) {
            this.service.windowOpen(archivo, '_blank');
        } else {
            const itemsArray = this.accordionSubItems.toArray();
            this.listaDataAccordion?.forEach(dataAcc => {
                dataAcc.menuHijos?.forEach((hijo, index) => {
                    if (hijo.id === Number(archivo)) {
                        itemsArray[index].open();
                    }
                });
            });
        }
    }

    public desplegarTabla(nieto: DataAccordion, hijo: DataAccordion) {
        this.listaNotasNM = nieto.guiasNotas;
        hijo.menuHijos?.forEach(menuHijo => {
            const obj = document.getElementById('div_tabla_' + menuHijo.nombre + '_' + menuHijo.id);
            var elemento_span = document.getElementById('span_icon_' + menuHijo.nombre + '_' + menuHijo.id);
            if (nieto.nombre === menuHijo.nombre) {
                if (obj!.style.display == 'none') {
                    obj!.style.display = 'block';
                    elemento_span!.innerText = 'remove';
                } else {
                    obj!.style.display = 'none';
                    elemento_span!.innerHTML = 'add';
                }
            } else {
                obj!.style.display = 'none';
                elemento_span!.innerHTML = 'add';
            }
        });
    }

    public cerrarOpcionesHijas(menuHijo: DataAccordion) {
        menuHijo.menuHijos?.forEach(hijo => {
            const obj = document.getElementById('div_tabla_' + hijo.nombre + '_' + hijo.id);
            var elemento_span = document.getElementById('span_icon_' + hijo.nombre + '_' + hijo.id);
            obj!.style.display = 'none';
            elemento_span!.innerHTML = 'add';
        });

    }

    /**********************************************************************/
    /****************RESALTAR LA PALABRA CONSULTADA************************/
    /**********************************************************************/
    public mapaIdOptionOpen: Map<number, number> = new Map();
    buscarPalabra(filterValue: string) {
        this.listaDataAccordionFiltro = new Array();
        this.reiniciarAcordion(this.listaDataAccordion);
        let listaFiltro = this.filterItems(this.listaDataAccordion, filterValue.toLowerCase());
        if(listaFiltro.length > 0){
            listaFiltro?.forEach(element => {
                let hijosFiltrados = this.filterItems(element.menuHijos, filterValue.toLowerCase());
                element.menuHijos = hijosFiltrados;
                if(hijosFiltrados.length > 0){
                    if(filterValue != ''){
                        element.menuHijos[0].expanded = true;
                    }
                    this.listaDataAccordionFiltro.push(element);
                }
            });
        } 
        if(this.listaDataAccordionFiltro.length > 0 && filterValue != ''){
            this.listaDataAccordionFiltro[0].expanded = true;  
        }
    }

    filterItems(items: DataAccordion[], filterValue: string): DataAccordion[] {
        return items
            .map(item => ({
                ...item,
                hijos: this.filterItems(item.menuHijos, filterValue)
            }))
            .filter(item => item.nombre.toLowerCase().includes(filterValue) || item.hijos.length > 0);
    }

    reiniciarAcordion(items: DataAccordion[]){
        items?.forEach(element => {
            element.expanded = false;
            if(element.menuHijos.length > 0){
                this.reiniciarAcordion(element.menuHijos);
            }
        });
    }
}
